import { useEffect } from 'react';
import { useZoneProfileStore } from '../store/zoneProfileStore';
import { syncStoredRateCaps } from '../lib/rendererRateCapSync';

/** Re-applies each renderer's stored manual rate cap to the Connector whenever zone profiles load. */
export default function useRendererRateCapSync() {
  useEffect(() => {
    void syncStoredRateCaps(useZoneProfileStore.getState().zones);
    return useZoneProfileStore.subscribe((state, prev) => {
      if (state.zones !== prev.zones) void syncStoredRateCaps(state.zones);
    });
  }, []);
}
